module.exports = __webpack_public_path__ + "img/2.57432d7f.jpg";